import axios from 'axios';

const authHeaders = [
  'access-token',
  'client',
  'expiry',
  'token-type',
  'uid'
];

const setRequestInterceptor = () => {
  axiosInstance.interceptors.request.use(function (config) {
    // Do something before request is sent
    config.headers['X-Key-Inflection'] = 'camel';
    authHeaders.forEach(headerName => {
      config.headers[headerName] = localStorage.getItem(headerName);
    });
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });
};

const setResponseInterceptor = () => {
  axiosInstance.interceptors.response.use(function (response) {
    if (!response) { return; }
    if (response.headers['access-token']) {
      // We have a good status, update localStorage with the latest auth tokens
      setHeaders(response.headers);
    } else {
      logoutUser();
    }
    return response;
  }, function (error) {
    if (!error.response || !error.response.status) return Promise.reject(error);
    if (error.response.status === 404 && !error.response.headers['access-token']) {
      // We have a good status, update localStorage with the latest auth tokens
      setHeaders(error.response.headers);
    }
    if (error.response.status === 401) {
      logoutUser();
    }
    return Promise.reject(error);
  });
};

const logoutUser = () => {
  localStorage.removeItem('user');
  window.location = '/login';
};

const setHeaders = (headers) => {
  authHeaders.forEach(headerName => {
    localStorage.setItem(headerName, headers[headerName]);
  });
};

const axiosInstance = axios.create({
  baseURL: process.env.LOGIN_URL
});

setRequestInterceptor();
setResponseInterceptor();

export default axiosInstance;



// WEBPACK FOOTER //
// ./src/helpers/axios.helper.js